import React from 'react';

import { IconDownload } from 'svgIcons/MotionPortalIcons';
import { formatDateTime } from 'helpers/dateTimeFormatter';

const exportParametersIcon = (id, onDownloadFile) => {

    const handleDownload = () => {
        onDownloadFile(id);
    };

    return <div className='parameter-backup-download-button'
        onClick={handleDownload}
        tabIndex={0}
        role='button'
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleDownload();
            }
        }}
    >
        <IconDownload
            width={16}
            height={16}
        />
    </div>;
};

export const getColumns = (translate, onDownloadFile) => {
    return [
        {
            title: translate('ABB.Powertrain.Frontend.parameterBackupFile'),
            dataIndex: 'timestamp',
            isSorting: true,
            width: 250,
            render: (timestamp) => formatDateTime(timestamp)
        },
        {
            title: translate('ABB.Powertrain.Frontend.parameterBackupType'),
            dataIndex: 'fileName',
            isSorting: true,
            width: 250,
            render: (fileName) => {
                if (!fileName) { return ''; }
                const extension = fileName.split('.').pop();
                return extension ? extension.toUpperCase() : '';
            }
        },
        {
            title: translate('ABB.Powertrain.Frontend.parameterBackupActions'),
            dataIndex: 'action',
            render: (_, item) => exportParametersIcon(item.fileId, onDownloadFile)
        }
    ];
};
